import { observer } from 'mobx-react';
import convertRecipientsToViewState from 'owa-mail-reading-pane-store/lib/utils/convertRecipientsToViewState';
import { loadAllRecipientsForItem } from 'owa-mail-store-actions';
import mailStore from 'owa-mail-store/lib/store/Store';
import ReadOnlyCompactRecipientWell from 'owa-readonly-recipient-well/lib/components/ReadOnlyCompactRecipientWell';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import RecipientCountsType from 'owa-service/lib/contract/RecipientCountsType';
import * as React from 'react';
import { highlightTermsInHtmlElement } from 'owa-mail-highlight-terms';

const styles = require('./ConversationReadingPane.scss');

export interface RecipientWellProps {
    toRecipients: EmailAddressWrapper[];
    ccRecipients: EmailAddressWrapper[];
    bccRecipients: EmailAddressWrapper[];
    itemId: string;
    recipientCounts: RecipientCountsType;
}

@observer
export default class RecipientWell extends React.Component<RecipientWellProps, any> {
    render() {
        const convertedToRecipients = convertRecipientsToViewState(this.props.toRecipients);
        const convertedCcRecipients = convertRecipientsToViewState(this.props.ccRecipients);
        const convertedBccRecipients = convertRecipientsToViewState(this.props.bccRecipients);
        return (
            <div className={styles.recipientWell}>
                <ReadOnlyCompactRecipientWell
                    toRecipients={convertedToRecipients}
                    ccRecipients={convertedCcRecipients}
                    bccRecipients={convertedBccRecipients}
                    recipientCounts={this.props.recipientCounts}
                    getAllRecipientsHandler={this.getAllRecipients}
                    recipientPersonaRef={highlightTermsInHtmlElement}
                />
            </div>
        );
    }

    private getAllRecipients = () => {
        loadAllRecipientsForItem(mailStore.items.get(this.props.itemId));
    };
}
